import { Button, DialogActions, withStyles } from '@material-ui/core';
import React from 'react';

const styles = (theme) => ({
  container: {
    paddingRight: 100,
    paddingLeft: 24,
    margin: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px'
  },
  button: {
    fontSize: theme.headerTextFontSize,
    textTransform: 'none',
    borderRadius: '2px',
    float: 'right',
    padding: '4px 10px'
  }
});

const DialogActionContainer = ({
  classes,
  currentStep,
  stepsLength,
  goNext,
  goBack,
  goBackToTrailerInput,
  runOptimizer,
  onCancel,
  showCancelButton = true
}) => {
  const isFinalStep = currentStep === stepsLength - 1;
  return (
    <DialogActions classes={{ root: classes.container }}>
      <div className={classes.buttonGroup}>
        <Button
          className={classes.button}
          variant="outlined"
          color="primary"
          size="medium"
          onClick={goBackToTrailerInput}>
          Go Back to Trailer Input
        </Button>
      </div>
      <div className={classes.buttonGroup}>
        {showCancelButton && (
          <Button
            className={classes.button}
            variant="text"
            color="primary"
            size="medium"
            onClick={onCancel}>
            Cancel
          </Button>
        )}
        {currentStep !== 0 && (
          <Button
            className={classes.button}
            variant="outlined"
            color="primary"
            size="medium"
            onClick={goBack}>
            Back
          </Button>
        )}
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          size="medium"
          onClick={isFinalStep ? runOptimizer : goNext}>
          {isFinalStep ? 'Run Optymizer' : 'Next'}
        </Button>
      </div>
    </DialogActions>
  );
};

export default withStyles(styles)(DialogActionContainer);
